module.exports = __webpack_public_path__ + "favicon-64.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/web/favicon-64.ico
// module id = 1064
// module chunks = 0